import React, { useEffect } from "react"
import ProductOption from "../ProductOption"
import SlicingServiceBanner from "../SlicingServiceBanner"

const Products = (props) => {
    const showSlicingService = props.product.section_name === "Chleby";
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [props.product.section_name]);
    
    return (
            <>
            {showSlicingService && <SlicingServiceBanner />}
            {props.product.products.map((product) => {
                return (
                    <ProductOption product={product} key={product.name} />
                )
            })}
            </>
    )
}

export default Products
